import { cartLinkStyles } from "@insite/content-library/Widgets/Common/CartLink";
import { colorPalette, fontFamily } from "@solveindustrial/Utilities/variables";

cartLinkStyles.routerLink = {
    ...cartLinkStyles.routerLink,
    hoverStyle: {
        color: (colorPalette.common as any).global.white,
    },
    icon: {
        ...cartLinkStyles.routerLink?.icon,
        iconProps: {
            ...cartLinkStyles.routerLink?.icon?.iconProps,
            size: 20,
        },
    },
    typographyProps: {
        ...cartLinkStyles.routerLink?.typographyProps,
        size: "18px",
        lineHeight: "20px",
        weight: 400,
        transform: "none",
        fontFamily,
    },
};
